import i18n from '../../../i18n';
import { getStore } from '../../../store/store-accessor';
import { enqueueNotification } from '../../../store/notification/action';

// Matches the `error` code the API guard returns for a blocked mutation while
// impersonating (see impersonation.guard.ts).
export const IMPERSONATION_READ_ONLY_CODE = 'IMPERSONATION_READ_ONLY';

export const isImpersonationReadOnlyError = (error: any): boolean =>
  error?.response?.status === 403 &&
  error?.response?.data?.error === IMPERSONATION_READ_ONLY_CODE;

let lastNotifiedAt = 0;

// Shown from an axios interceptor (no React context), so we go through the
// store directly. De-duped because a single page action can fire several
// blocked mutations at once.
export const notifyImpersonationReadOnly = (): void => {
  const now = Date.now();
  if (now - lastNotifiedAt < 1500) {
    return;
  }
  lastNotifiedAt = now;
  getStore()?.dispatch(
    enqueueNotification(
      i18n.t(
        'impersonation.readOnlyError',
        'This action is not available while impersonating a user — the session is read-only.',
      ),
      'warning',
      4000,
    ),
  );
};
